import { StockAreaModal } from "./stock-area-modal";

export class SearchModal{
   stockArea: StockAreaModal;
   assetId: string;
   searchBy: string;
}